import axios, { AxiosError } from 'axios';

// LLM service URL (should be in environment variable)
const LLM_SERVICE_URL = import.meta.env.VITE_LLM_SERVICE_URL;

interface SummaryResponse {
  name: string;
  detail: string;
}

interface ErrorResponse {
  error: string;
  detail?: string;
}

export async function summarizeUrl(url: string): Promise<SummaryResponse> {
  try {
    const response = await axios.post<SummaryResponse>(`${LLM_SERVICE_URL}/api/summarize-url`, { url });
    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError<ErrorResponse>;
    if (axiosError.response?.data) {
      throw new Error(axiosError.response.data.detail || axiosError.response.data.error);
    }
    throw new Error('Failed to summarize URL');
  }
}

export async function summarizeText(content: string): Promise<SummaryResponse> {
  try {
    const response = await axios.post<SummaryResponse>(`${LLM_SERVICE_URL}/api/summarize-text`, { content });
    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError<ErrorResponse>;
    if (axiosError.response?.data) {
      throw new Error(axiosError.response.data.detail || axiosError.response.data.error);
    }
    throw new Error('Failed to summarize text');
  }
} 